import { React, useState, useRef, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { FxMap } from "./map/FxMap";
import { FxmsData } from "../datas/FxData";
import Dialog from "@mui/material/Dialog";
import { Modal } from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import common from "../jwt/auth-axios-common";

import "./../../css/FxTPDataGrid.css";

// 데이터그리드 생성
// 월간 평균 / 주간 평균 / 금일 평균
// 속성 수소생산 / 수소저장 / 연료전지발전
const columns = [
  {
    field: "avgValue",
    headerName: "-",
    width: 100,
    headerClassName: "gridHeader",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "hydroProduction",
    headerName: "수소생산",
    width: 100,
    headerClassName: "gridHeader",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "hydroStored",
    headerName: "수소저장",
    width: 100,
    headerClassName: "gridHeader",
    align: "center",
    headerAlign: "center",
  },
  {
    field: "powerGeneration",
    headerName: "연료전지발전",
    width: 130,
    headerClassName: "gridHeader",
    align: "center",
    headerAlign: "center",
  },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const FxTPDataGrid = (props) => {
  const [open, setOpen] = useState(props.open);
  const title = "111";
  const [image, setImage] = useState("tank.png");
  const outSide = useRef();
  const [inloNo, setInloNo] = useState(props.inloNo);
  const [url, setUrl] = useState(props.url);
  const [isOperate, setIsOperate] = useState(false);
  const [name, setName] = useState("H2");
  const [temperature, setTemperature] = useState(8);
  const [fineDust, setFineDust] = useState(21);
  const [ultraFineDust, setUltraFineDust] = useState(13);
  const [rows, setRows] = useState([
    {
      id: "a",
      avgValue: "월간 평균",
      hydroProduction: "0",
      hydroStored: "0",
      powerGeneration: "0",
    },
    {
      id: "b",
      avgValue: "주간 평균",
      hydroProduction: "0",
      hydroStored: "0",
      powerGeneration: "0",
    },
    {
      id: "c",
      avgValue: "금일 평균",
      hydroProduction: "0",
      hydroStored: "0",
      powerGeneration: "0",
    },
  ]);

  useEffect(() => {
    FxmsData.GET("open/air/" + props.url)
      .then(function (res) {
        console.log("dddd");
        let result = res.data;
        if (result) {
          console.log(result);
          //let infos = [];
          setIsOperate(result.isOperate);
          setImage(result.image);
          setName(result.name);
          setTemperature(result.temperature);
          setFineDust(result.fineDust);
          setUltraFineDust(result.ultraFineDust);
          setRows(result.infomation);
        }
      })
      .catch(function (error) {
        console.log(error.toJSON);
      });
  }, []);

  useEffect(() => {
    const clickOutside = (e) => {
      // 모달이 열려 있고 모달의 바깥쪽을 눌렀을 때 창 닫기
      if (open && outSide.current && !outSide.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", clickOutside);

    return () => {
      document.removeEventListener("mousedown", clickOutside);
    };
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} ref={outSide}>
      <Box sx={style}>
        <Button className="TPCloseButton" onClick={handleClose}>
          X
        </Button>
        <div className="apiContainer">
          <div className="TPtitle">
            <h1>{name}</h1>
          </div>
          <div className="apiValue">
            외기 온도: {temperature} ℃
            <br />
            미세먼지: {fineDust} ug <br />
            초미세먼지: {ultraFineDust} ug <br />
          </div>
          <div className="TPimageContainer">
            <img className="TPimage" src={image}></img>
          </div>
        </div>
        <Box
          className="TPbox"
          sx={{
            "& .gridHeader": {
              backgroundColor: "white",
            },
          }}
        >
          <DataGrid
            rows={rows}
            columns={columns}
            hideFooter={true}
            sx={{
              backgroundColor: "white",
              "& .MuiDataGrid-cell:hover": {
                color: "primary.main",
              },
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};
